import * as React from 'react';
import { Features } from '../api/types/types';
const {Provider, Consumer} = React.createContext<Features | null>(null);
export const FeaturesProvider = Provider;
export const FeaturesConsumer = Consumer;